export default __webpack_public_path__ + "static/media/208-tile.fc8a3599.svg";